module.exports = __webpack_public_path__ + "static/img/cs.4d19715f.png";